import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const ChannelsCollections = React.lazy(() => import("@mediaspace/features/channels-collections"));

export const render = getDsLayoutComponentRenderer(ChannelsCollections);
